"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var chart_js_1 = require("chart.js");
var chartjs_plugin_datalabels_1 = __importDefault(require("chartjs-plugin-datalabels"));
// @ts-ignore – no official types
var plugin_colorschemes_1 = __importDefault(require("chartjs-plugin-colorschemes/src/plugins/plugin.colorschemes"));
// @ts-ignore – no official types
var colorschemes_brewer_1 = require("chartjs-plugin-colorschemes/src/colorschemes/colorschemes.brewer");
var ChartisanJS_1 = require("../ChartisanJS");
window.Chartisan = ChartisanJS_1.Chartisan;
window.ChartisanHooks = ChartisanJS_1.ChartisanHooks;
function charts() {
    // Register plugins globally
    chart_js_1.Chart.plugins.register(chartjs_plugin_datalabels_1.default);
    chart_js_1.Chart.plugins.register(plugin_colorschemes_1.default);
    // Merge default datalabels options
    if (chart_js_1.Chart.defaults.global.plugins) {
        chart_js_1.Chart.helpers.merge(chart_js_1.Chart.defaults.global.plugins.datalabels, {
            align: "end",
            anchor: "end",
            font: { weight: "bold" },
        });
    }
    // Select all chart elements
    var allCharts = document.querySelectorAll(".chart");
    allCharts.forEach(function (el) {
        var _a;
        var chart = new ChartisanJS_1.Chartisan({
            // chart: Chart,
            el: el.id ? "#".concat(el.id) : undefined,
            url: (_a = el.dataset.url) !== null && _a !== void 0 ? _a : "",
            hooks: new ChartisanJS_1.ChartisanHooks()
                .options({
                type: "horizontalBar",
                options: {
                    legend: {
                        labels: {
                            fontSize: 20,
                        },
                    },
                    plugins: {
                        colorschemes: {
                            scheme: colorschemes_brewer_1.PastelTwo8,
                        },
                    },
                },
            })
                .beginAtZero(true),
        });
        chart.update({ background: true });
    });
}
exports.default = charts;
